import CompressionWorker from '../workers/compression.worker?worker&inline';
/*
 *This function will send non-blocking gzip tasks to WebWorker and return the zipped data as a Promise
 */
/* istanbul ignore next --- web workers not used in node */
export const nonBlockingGzip = (payload: string): Promise<Uint8Array> =>
  new Promise((resolve, reject) => {
    /*
     *const compressionWorker = new Worker(new URL('../workers/compression.worker.ts', import.meta.url), {
     *  type: 'module',
     *}); // Cannot use recommended syntax due to open issue: https://github.com/vitejs/vite/issues/11672
     */
    const compressionWorker = new CompressionWorker();
    compressionWorker.postMessage({ type: 'gzip', payload });
    compressionWorker.onmessage = (e) => {
      if (e?.data) {
        const { success, msg, payload } = e.data;
        if (success) {
          resolve(payload);
        } else {
          reject(msg);
        }
      }
      compressionWorker.terminate();
    };
  });
